// extracted by mini-css-extract-plugin
export default {"card_myRoadmap":"CardMyRoadmap_card_myRoadmap__WLdwy","bg_gradient":"CardMyRoadmap_bg_gradient__YNEck"};